import { ChangeDetectorRef, Component, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ListFolderDto } from 'src/app/_models/messaging/lists-and-contacts/list-folders/list-folder-dto';
import { ListFolderDtoAdapter } from 'src/app/_models/messaging/lists-and-contacts/list-folders/list-folder-dto.adapter';
import { ListFolderService } from 'src/app/_services/messaging/lists-and-contacts/list-folders/list-folder.service';
import { ListsService } from 'src/app/_services/messaging/lists-and-contacts/lists/lists.service';
import { ListModel } from 'src/app/_models/messaging/lists-and-contacts/lists/list-model';
import { ListModelAdapter } from 'src/app/_models/messaging/lists-and-contacts/lists/list-model.adapter';
import { ListFieldsModel } from 'src/app/_models/messaging/lists-and-contacts/lists/list-fields-model';
import { ListFieldsModelAdapter } from 'src/app/_models/messaging/lists-and-contacts/lists/list-fields-model.adapter';
import { RcsMessage, MessageType, Suggestion, SuggestionType } from '../../../../../../_models/messaging/messages/rcs-messages/rcs-message.model';
import { ValidationService } from '../../../../../../_services/messaging/messages/rcs-messages/validation.service';
import { SmsMessageService } from 'src/app/_services/messaging/messages/sms-messages/sms-message.service';
import { RcsMessageService } from 'src/app/_services/messaging/messages/rcs-messages/rcs-message.service';
import { RcsMessageDtoRequest, RcsSuggestionDto } from 'src/app/_models/messaging/messages/rcs-messages/rcs-message-dto-request';
import { RcsMessageDto } from 'src/app/_models/messaging/messages/rcs-messages/rcs-message-dto';
import { RcsMessageDtoAdapter } from 'src/app/_models/messaging/messages/rcs-messages/rcs-message-dto.adapter';
import { ClientInboxAdapter, ClientInboxDto } from 'src/app/_models/admin/clients/client-inboxes-model';
import { SelectListOption } from 'src/app/_models/system/select-list-option';
import { ExecutionResultDto } from 'src/app/_models/execution-result-model';
import { ExecutionResult } from 'src/app/_models/execution-result-enum';
import { NotificationService } from 'src/app/_services/notification.service';
import { LocalStorageService } from 'src/app/_services/system/localStorage/localStorage.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-rcs-text',
  templateUrl: './rcs-text.component.html',
  styleUrls: ['./rcs-text.component.scss']
})
export class RcsTextComponent implements OnInit, OnDestroy, OnChanges {
  private destroy$ = new Subject<void>();
  
  @Input() message: RcsMessage | null = null;
  @Output() messageChange = new EventEmitter<RcsMessage>();
  @ViewChild('insertWildcardModal', { static: true }) insertWildcardModal: ModalDirective;

  textContent: string = '';
  fallbackText: string = '';
  selectedSenderId: number = 0;
  textError: string = '';
  fallbackTextError: string = '';
  senderError: string = '';
  suggestions: Suggestion[] = [];
  SuggestionType = SuggestionType;
  suggestionErrors: { [key: string]: string } = {};
  _clientInboxSelectListOptions: SelectListOption[] = [];
  _showSpinner = false;
    _formGroupInsertWildcard: UntypedFormGroup;
  _listFolderSelectListOptions: SelectListOption[] = [];
  _listsSelecListOptions: SelectListOption[] = [];
  _listFieldsSelectListOptions: SelectListOption[] = [];
  _selectedListId = 0;
  _selectedListFieldId = 0;
  _selectedListFolderId = 0;
  _wildcardTarget: 'text' | 'fallback' = 'text';
  _selectionStart = 0;
  _subscriptionListFolders: Subscription;
  _subscriptionLists: Subscription;
  _subscriptionListFields: Subscription;

  newSuggestion: Suggestion = {
    type: SuggestionType.REPLY,
    displayText: ''
  };

  // Editing state for suggestions
  editingIndex: number = -1;
  editingSuggestion: Suggestion = {
    type: SuggestionType.REPLY,
    displayText: ''
  };
  editingSuggestionErrors: { [key: string]: string } = {};

  // Validation errors
  constructor(
    private cdr: ChangeDetectorRef,
    private validationService: ValidationService,
    private smsMessageService: SmsMessageService,
    private rcsMessageService: RcsMessageService,
    private rcsMessageDtoAdapter: RcsMessageDtoAdapter,
    private clientInboxDtoAdapter: ClientInboxAdapter,
    private notificationService: NotificationService,
    private localStorageService: LocalStorageService,
    private listFolderService: ListFolderService,
    private listFolderDtoAdapter: ListFolderDtoAdapter,
    private listsService: ListsService,
    private listModelAdapter: ListModelAdapter,
    private listFieldsModelAdapter: ListFieldsModelAdapter
  ) {}

  ngOnInit(): void {
    this.initWildcardForm();
    this.populateListFoldersDropdown();
    this.subscribeToWildcardFormControls();
    this.populateSendersDropdown();
    
    // IMPORTANT: Do NOT use @Input message here for edit mode!
    // In edit mode, message is loaded via ngOnChanges from message-builder
    // In create mode, message will be set later via @Input or ngOnChanges
    
    if (this.message?.text) {
      this.textContent = this.message.text;
    }
    if (this.message?.suggestions) {
      this.suggestions = [...this.message.suggestions];
    }
    if (this.message?.fallbackText) {
      this.fallbackText = this.message.fallbackText;
    }
    if (this.message?.fallbackSenderId) {
      this.selectedSenderId = parseInt(this.message.fallbackSenderId) || 0;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['message'] && changes['message'].currentValue) {
      const message = changes['message'].currentValue as RcsMessage;
      
      if (message.text) {
        this.textContent = message.text;
      }
      if (message.suggestions) {
        this.suggestions = [...message.suggestions];
      }
      if (message.fallbackText) {
        this.fallbackText = message.fallbackText;
      }
      if (message.fallbackSenderId) {
        this.selectedSenderId = parseInt(message.fallbackSenderId) || 0;
      }
      
      this.updateMessage();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    
    this._subscriptionListFolders?.unsubscribe();
    this._subscriptionLists?.unsubscribe();
    this._subscriptionListFields?.unsubscribe();
  }

  initWildcardForm(): void {
    this._formGroupInsertWildcard = new UntypedFormGroup({
      listFolders: new UntypedFormControl({ value: 0, disabled: true }, Validators.required),
      lists: new UntypedFormControl({ value: 0, disabled: true }, Validators.required),
      listFields: new UntypedFormControl({ value: 0, disabled: true }, Validators.required)
    });
  }

  rememberSelection(event: any, target: 'text' | 'fallback'): void {
    if (event?.target?.selectionStart !== undefined) {
      this._selectionStart = event.target.selectionStart;
    }
    this._wildcardTarget = target;
  }

  openWildcard(target: 'text' | 'fallback', inputEl: HTMLTextAreaElement | HTMLInputElement): void {
    this._wildcardTarget = target;
    this._selectionStart = inputEl?.selectionStart || 0;
    this._formGroupInsertWildcard.reset({ listFolders: 0, lists: 0, listFields: 0 });
    this.insertWildcardModal.show();
  }

  insertWildcardModalSubmit(): void {
    const field = this._listFieldsSelectListOptions.find(x => x.value === this._selectedListFieldId)?.simpleName || '';
    const targetValue = this._wildcardTarget === 'fallback' ? this.fallbackText : this.textContent;
    const before = targetValue.substring(0, this._selectionStart);
    const after = targetValue.substring(this._selectionStart);
    const withWildcard = `${before}${field}${after}`;

    if (this._wildcardTarget === 'fallback') {
      this.fallbackText = withWildcard;
      this.onFallbackTextChange();
    } else {
      this.textContent = withWildcard;
      this.onTextChange();
    }

    this.insertWildcardModal.hide();
  }

  subscribeToWildcardFormControls(): void {
    this._subscriptionListFolders = this._formGroupInsertWildcard.get('listFolders')?.valueChanges.subscribe(folderId => {
      this._selectedListFolderId = folderId;
      this.populateListsDropdown();
    });
    this._subscriptionLists = this._formGroupInsertWildcard.get('lists')?.valueChanges.subscribe(listId => {
      this._selectedListId = listId;
      this.populateListFieldsDropdown();
    });
    this._subscriptionListFields = this._formGroupInsertWildcard.get('listFields')?.valueChanges.subscribe(listFieldId => {
      this._selectedListFieldId = listFieldId;
    });
  }

  populateSendersDropdown(): void {
    this.smsMessageService.getClientInboxes().subscribe((executionResultDto: ExecutionResultDto) => {
      this._showSpinner = true;

      if (executionResultDto.executionResult === ExecutionResult.success) {
        const clientInboxDtos = executionResultDto.data
          .map((clientInboxDto: ClientInboxDto) => this.clientInboxDtoAdapter.adapt(clientInboxDto));

        this._clientInboxSelectListOptions = clientInboxDtos.map((clientInboxDto: ClientInboxDto) =>
          new SelectListOption(clientInboxDto.id, `(${clientInboxDto.InboxNumber}) ${clientInboxDto.InboxName}`));
      } else {
        this.notificationService.showError(executionResultDto.message);
      }
      this._showSpinner = false;
    }, error => this._showSpinner = false);
  }

  validateFallbackText(): void {
    this.fallbackTextError = '';
    if (!this.fallbackText || this.fallbackText.trim() === '') {
      this.fallbackTextError = 'Fallback text is required';
      return;
    }
    const profanityCheck = this.validationService.validateTextForProfanity(this.fallbackText);
    if (!profanityCheck.valid) {
      this.fallbackTextError = profanityCheck.error || '';
    }
  }

  onFallbackTextChange(): void {
    this.validateFallbackText();
    this.updateMessage();
  }

  onSenderChange(): void {
    if (this.selectedSenderId === 0) {
      this.senderError = 'Please select a sender';
    } else {
      this.senderError = '';
    }
    this.updateMessage();
  }

  onTextChange(): void {
    this.validateText();
    this.updateMessage();
  }

  validateText(): void {
    this.textError = '';
    if (this.textContent.length > 8000) {
      this.textError = `Message text must not exceed 8000 characters (currently ${this.textContent.length}).`;
      return;
    }
    const profanityCheck = this.validationService.validateTextForProfanity(this.textContent);
    if (!profanityCheck.valid) {
      this.textError = profanityCheck.error || '';
      return;
    }
  }

  addSuggestion(): void {
    const result = this.validationService.validateSuggestion(this.newSuggestion);
    this.suggestionErrors = { ...result.errors };
    if (!result.valid) {
      this.cdr.detectChanges();
      return;
    }

    this.suggestions.push({ ...this.newSuggestion });
    this.resetNewSuggestion();
    this.updateMessage();
  }

  removeSuggestion(index: number): void {
    this.suggestions.splice(index, 1);
    this.updateMessage();
  }

  editSuggestion(index: number): void {
    this.editingIndex = index;
    this.editingSuggestion = { ...this.suggestions[index] };
    this.editingSuggestionErrors = {};
  }

  saveEditingSuggestion(): void {
    const result = this.validationService.validateSuggestion(this.editingSuggestion);
    this.editingSuggestionErrors = { ...result.errors };
    if (!result.valid) {
      this.cdr.detectChanges();
      return;
    }

    this.suggestions[this.editingIndex] = { ...this.editingSuggestion };
    this.cancelEditingSuggestion();
    this.updateMessage();
  }

  cancelEditingSuggestion(): void {
    this.editingIndex = -1;
    this.editingSuggestion = {
      type: SuggestionType.REPLY,
      displayText: ''
    };
    this.editingSuggestionErrors = {};
  }

  onEditingSuggestionTypeChange(): void {
    // Reset type-specific fields when type changes
    this.editingSuggestion.url = undefined;
    this.editingSuggestion.phone = undefined;
    this.editingSuggestion.address = undefined;
    this.editingSuggestion.latitude = undefined;
    this.editingSuggestion.longitude = undefined;
    this.editingSuggestion.meetingTitle = undefined;
    this.editingSuggestion.meetingDescription = undefined;
    this.editingSuggestion.startTime = undefined;
    this.editingSuggestion.endTime = undefined;
    this.editingSuggestionErrors = {};
  }

  onSuggestionTypeChange(): void {
    // Reset suggestion-specific fields when type changes
    this.newSuggestion.url = undefined;
    this.newSuggestion.phone = undefined;
    this.newSuggestion.address = undefined;
    this.newSuggestion.latitude = undefined;
    this.newSuggestion.longitude = undefined;
    this.newSuggestion.startTime = undefined;
    this.newSuggestion.endTime = undefined;
    this.newSuggestion.meetingTitle = undefined;
    this.newSuggestion.meetingDescription = undefined;
    this.suggestionErrors = {};
  }

  validateSuggestionField(field: string, _value: any): void {
    const result = this.validationService.validateSuggestion(this.newSuggestion);
    this.suggestionErrors = { ...result.errors };
    this.cdr.detectChanges();
  }

  resetNewSuggestion(): void {
    this.newSuggestion = {
      type: SuggestionType.REPLY,
      displayText: ''
    };
    this.suggestionErrors = {};
  }

  updateMessage(): void {
    const updatedMessage: RcsMessage = {
      type: MessageType.TEXT,
      text: this.textContent,
      suggestions: this.suggestions.length > 0 ? [...this.suggestions] : undefined,
      fallbackText: this.fallbackText,
      fallbackSenderId: this.selectedSenderId ? this.selectedSenderId.toString() : undefined,
      timestamp: new Date()
    };
    this.messageChange.emit(updatedMessage);
  }

  populateListFoldersDropdown(): void {
  this._showSpinner = true;
  this._formGroupInsertWildcard.get('listFolders')?.disable();

  this.listFolderService.getAll().subscribe((executionResultDto: ExecutionResultDto) => {
    if (executionResultDto.executionResult === ExecutionResult.success) {
      const listFolderDtos = executionResultDto.data
        .map((dto: ListFolderDto) => this.listFolderDtoAdapter.adapt(dto));

      this._listFolderSelectListOptions = listFolderDtos.map((dto: ListFolderDto) =>
        new SelectListOption(dto.id, dto.name));
    } else {
      this.notificationService.showError(executionResultDto.message);
    }
    this._showSpinner = false;
    this._formGroupInsertWildcard.get('listFolders')?.enable();
  }, () => {
    this._showSpinner = false;
    this._formGroupInsertWildcard.get('listFolders')?.enable();
  });
}

 populateListsDropdown(): void {
  if (!this._selectedListFolderId) { return; }

  this._showSpinner = true;
  this._formGroupInsertWildcard.get('lists')?.disable();

  this.listsService.getByFolderId(this._selectedListFolderId).subscribe((executionResultDto: ExecutionResultDto) => {
    if (executionResultDto.executionResult === ExecutionResult.success) {
      const listDtos = executionResultDto.data
        .map((dto: ListModel) => this.listModelAdapter.adapt(dto));

      this._listsSelecListOptions = listDtos.map((dto: ListModel) =>
        new SelectListOption(dto.ListID, dto.ListName));

      this._selectedListId = this._listsSelecListOptions.length === 1 ? this._listsSelecListOptions[0].value : 0;
      this._formGroupInsertWildcard.get('lists')?.setValue(this._selectedListId);
    } else {
      this.notificationService.showError(executionResultDto.message);
    }
    this._showSpinner = false;
    this._formGroupInsertWildcard.get('lists')?.enable();
  }, () => {
    this._showSpinner = false;
    this._formGroupInsertWildcard.get('lists')?.enable();
  });
}

  populateListFieldsDropdown(): void {
    if (!this._selectedListId) { return; }

    this._showSpinner = true;
    this._formGroupInsertWildcard.get('listFields')?.disable();

    this.listsService.getWildcardListFields(this._selectedListId).subscribe((executionResultDto: ExecutionResultDto) => {
      if (executionResultDto.executionResult === ExecutionResult.success) {
        const listFieldDtos = executionResultDto.data
          .map((dto: ListFieldsModel) => this.listFieldsModelAdapter.adapt(dto));

        this._listFieldsSelectListOptions = listFieldDtos.map((dto: ListFieldsModel) => {
          const label = dto.FieldName || dto.DisplayName;
          return new SelectListOption(dto.FieldID, label, dto.Wildcard);
        });

        this._selectedListFieldId = this._listFieldsSelectListOptions.length === 1
          ? this._listFieldsSelectListOptions[0].value
          : 0;

        this._formGroupInsertWildcard.get('listFields')?.setValue(this._selectedListFieldId);
      } else {
        this.notificationService.showError(executionResultDto.message);
      }
      this._showSpinner = false;
      this._formGroupInsertWildcard.get('listFields')?.enable();
    }, () => {
      this._showSpinner = false;
      this._formGroupInsertWildcard.get('listFields')?.enable();
    });
  }

  save(messageId: number = 0, messageName: string = '', folderId: number = 0): Promise<number> {
    return new Promise((resolve, reject) => {
      this.validateAll();
      
      if (this.hasValidationErrors()) {
        this.notificationService.showError('Please fix validation errors before saving');
        reject(new Error('Validation errors'));
        return;
      }

    const rcsContentJson = JSON.stringify({
      type: 'text',
      text: this.textContent
    });

    const rcsMessageDtoRequest = new RcsMessageDtoRequest({
      id: messageId,
      folderId: folderId,
      name: messageName,
      rcsType: 'text',
      rcsContentJson: rcsContentJson,
      suggestions: this.suggestions.map(s => ({
        type: s.type,
        displayText: s.displayText,
        suggestionScope: 'global',
        url: s.url,
        phone: s.phone,
        address: s.address,
        latitude: s.latitude,
        longitude: s.longitude,
        startTime: s.startTime,
        endTime: s.endTime,
        meetingTitle: s.meetingTitle,
        meetingDescription: s.meetingDescription
      })),
      smsFallbackEnabled: true,
      smsFallbackText: this.fallbackText,
      smsFallbackClientInboxId: this.selectedSenderId
    });

    this._showSpinner = true;

      this.rcsMessageService.save(rcsMessageDtoRequest).subscribe((executionResultDto: ExecutionResultDto) => {
        if (executionResultDto.executionResult === ExecutionResult.success) {
          const rcsMessageDto = this.rcsMessageDtoAdapter.adapt(executionResultDto.data);
          this.notificationService.showSuccess('RCS message saved successfully');
          // Emit the saved message back to parent component
          this.messageChange.emit({
            ...this.message,
            text: this.textContent,
            suggestions: this.suggestions
          });
          resolve(rcsMessageDto.messageId || messageId);
        } else {
          this.notificationService.showError(executionResultDto.message);
          reject(new Error(executionResultDto.message));
        }
        this._showSpinner = false;
      }, error => {
        this.notificationService.showError('Error saving RCS message');
        this._showSpinner = false;
        reject(error);
      });
    });
  }

  private hasValidationErrors(): boolean {
    return !!(this.textError || this.fallbackTextError || this.senderError ||
      Object.keys(this.suggestionErrors).length > 0);
  }

  load(messageId: number): void {
    if (messageId <= 0) {
      return;
    }

    this._showSpinner = true;
    this.rcsMessageService.get(messageId).subscribe((executionResultDto: ExecutionResultDto) => {
      if (executionResultDto.executionResult === ExecutionResult.success) {
        const rcsMessageDto = this.rcsMessageDtoAdapter.adapt(executionResultDto.data);
        this.loadFromRcsMessage(rcsMessageDto);
      } else {
        this.notificationService.showError(executionResultDto.message || 'Failed to load RCS message');
      }
      this._showSpinner = false;
    }, error => {
      this.notificationService.showError('Error loading RCS message');
      this._showSpinner = false;
      console.error('Error loading RCS message:', error);
    });
  }

  private loadFromRcsMessage(rcsMessageDto: any): void {
    try {
      const contentJsonStr = rcsMessageDto.rcsContentJson || rcsMessageDto.RCSContentJson;
      const rcsContent = JSON.parse(contentJsonStr);
      
      if (rcsContent.type === 'text') {
        this.textContent = rcsContent.text || '';
        this.suggestions = rcsContent.suggestions || [];
      }
      
      this.fallbackText = rcsMessageDto.smsFallbackText || '';
      this.selectedSenderId = rcsMessageDto.smsFallbackClientInboxId || 0;
      
      this.updateMessage();
    } catch (error) {
      this.notificationService.showError('Invalid message format');
      console.error('Load error', error);
    }
  }

  private validateAll(): void {
    this.validateText();
    this.validateFallbackText();
    this.validateSender();
    this.validateSuggestions();
  }

  private validateSender(): void {
    this.senderError = '';
    if (this.selectedSenderId === 0) {
      this.senderError = 'Please select a sender';
    }
  }

  private validateSuggestions(): void {
    this.suggestionErrors = {};
    // Add suggestion validation logic if needed
  }

  resetForm(): void {
    // Reset all form data
    this.textContent = '';
    this.fallbackText = '';
    this.selectedSenderId = 0;
    this.suggestions = [];
    
    // Clear errors
    this.textError = '';
    this.fallbackTextError = '';
    this.senderError = '';
    this.suggestionErrors = {};
    
    // Reset message
    this.message = {
      type: MessageType.TEXT,
      text: '',
      suggestions: []
    };
    
    // Emit reset message to parent
    this.messageChange.emit(this.message);
  }
}
